import Form from './Form';
import {formatPrice, getUrlVar} from './utils';

// TODO: refactor jQuery --> ES
/**
 * #FIXME: Make Eteilefinder great Again vong Syntachse her
 */
export default class EteileFinder {
	constructor(app) {
		this.app = app;
		const self = this;

		if (!$('.js-outerwrap').hasClass('ersatzteile') && !$('.js-outerwrap').hasClass('eteilmail')) {
			if (this.app.info.isDebug) {
				console.debug("not init, not eteile finder");
			}
			return;
		}

		var cart = [];

		self.baseURL = window.location.origin + "/ersatzteile";

		self.steps = {
			0: {
				"kind": "produkttyp",
				"container": "#producttype_container",
				"key-holder": "producttype",
				"action": listSeries,

			},
			1: {
				"kind": "serie",
				"container": "#serie_container",
				"key-holder": "id",
				"action": listArticle,

			},
			2: {
				"kind": "artikel",
				"container": "#artikel_container",
				"key-holder": "id",
				"action": listVariants,

			},
			3: {
				"kind": "variante",
				"container": "#varianten_container",
				"key-holder": "id",
				"action": listMontage,

			},
			4: {
				"kind": "montage",
				"container": "#draw",
			},
		};

		self.steps_length = Object.keys(self.steps).length;


		// history event
		window.addEventListener('popstate', function (e) {
			var state = e.state;
			console.debug('State: %o', state);
			if (state !== null) {
				handlePath(state.kind, state.key)
			}
		});

		function handlePath(kind, key) {
			console.debug("handlePath: kind: '%s', key: '%s'", kind, key);

			switch (kind.toLowerCase()) {
				case "producttype":
				case "produkttyp":
					listSeries(key);
					break;

				case "serie":
					listArticle(key);
					break;

				case "artikel":
					listVariants(key);
					break;

				case "variante":
				case "montage":
					eteil_render(key);
					break;

				case "term":
					$('.gpnrSearch-input').val(key);
					search();
					break;

				default:
					console.warn("Unknown kind '%s'. Dont know what to do...", kind);

			}
		}

		var json = $('.js-cartjson').val();
		if (json !== "None") {
			cart = JSON.parse(json);
			buildCart();
		}

		$('form.gpnrSearch').submit(function (event) {
			event.preventDefault();

			if ($('.gpnrSearch-input').val() !== "") {
				search();
				return false;
			}
		});

		Form.addressAutocomplete({
			form: document.querySelector('#eteil_add'),
			options: {
				bounds: Form.EUROPE_BOUNDS,
				strictBounds: true,
			}
		});


		function buildSelection() {
			// save user-click-path in a form-input
			var selection = "";
			$("#serie_container .js-ef-item.active").each(function (i, v) {
				selection += $(this).find("h2").text() + ", "
			});

			$("#artikel_container .js-ef-item.active").each(function (i, v) {
				selection += $(this).find("h3").text() + ", "
			});
			$("#varianten_container .js-ef-item.active").each(function (i, v) {
				selection += $(this).find(".media-headline").text()
			});
			$("input[name=selection]").val(selection.replace(/\n|\r/g, ""))
		}


		for (let i in self.steps) {
			i = parseInt(i);

			let step = self.steps[i];

			$(document).on("click", step["container"] + " .js-ef-item", function (e, data) {
				let $this = $(e.target).closest(".js-ef-item");
				let key = $this.data(step["key-holder"]);

				$(step["container"] + " .js-ef-item").removeClass("active");
				$this.addClass("active");

				// console.log("Clicked", $this, key, data, e);

				// show next selector
				if (i + 1 < self.steps_length) {
					$(".step" + (i + 1) + "-intro").removeClass('is-disabled');
					$(self.steps[i + 1]["container"]).show().addClass("simpleloader").html("");
				}

				// disable following
				for (let j = i + 2; j < self.steps_length; j++) {
					$(self.steps[j]["container"]).hide();
					$(".step" + j + "-intro").addClass('is-disabled');
				}

				if (typeof step["action"] === "function")
					step["action"](key, $(this), e, data);

				buildSelection();

				if (data === undefined || data.noHistory !== true)
					history.pushState({
						"kind": step["kind"],
						"key": key
					}, null, self.baseURL + "/" + step["kind"] + "/" + key);
			})
		}

		function listSeries(producttype) {
			$(".step1-intro").removeClass('is-disabled');
			$("#serie_container").show().addClass("simpleloader").html("");
			scrollToId("#serie_container");

			$.ajax({
				url: "/serie/list?style=montage&produkttyp=" + producttype,
				success: function (data) {
					if (data) {
						$("#serie_container").removeClass("simpleloader").html(data);
					}
				}
			})
		}


		function listArticle(serieKey) {
			$(".step2-intro").removeClass('is-disabled');
			$("#artikel_container").show().addClass("simpleloader").html("");
			scrollToId("#artikel_container");

			$.ajax({
				url: "/produkt/list?amount=99&style=montage&serie.dest.key=" + serieKey,
				success: function (data) {
					if (data) {
						$("#artikel_container").removeClass("simpleloader").html(data);
					}
				}
			});
		}

		function listVariants(productKey, $this) {
			let producttype;

			if (typeof ($this) === "undefined") {
				$.ajax({
					url: "/json/produkt/view/" + productKey,
					dataType: "json",
					async: false,
					success: function (data) {
						producttype = data["values"]["produkttyp"];
					}
				});
			} else {
				producttype = $this.data("producttype");
			}

			if (!producttype) {
				console.error("No producttype?!");
				return;
			}

			$(".step3-intro").removeClass('is-disabled');
			$("#varianten_container").show().addClass("simpleloader").html("");
			scrollToId("#varianten_container");

			$.ajax({
				url: "/montageanleitung/list?style=montage&" + producttype + "_produkt.dest.key=" + productKey, //url
				success: function (data) {
					if (data) {
						$("#varianten_container").removeClass("simpleloader").html(data);
						scrollToId("#varianten_container");
					}
				}
			})
		}

		function listMontage(variantsKey, $this) {
			if (cart.length > 0) {
				if (!confirm("ACHTUNG! Beim ändern des Produkts wird der aktuelle Warenkorb geleert!")) {
					return false;
				} else {
					cart = [];
					buildCart();
				}
			}

			// select variante active
			$(self.steps[3]["container"] + " .js-ef-item").removeClass("active");
			$this.addClass("active");

			eteil_render(variantsKey);
		}

		function search() {
			// show montageanleitung selector
			$(".step3-intro").removeClass('is-disabled');
			$("#varianten_container").show().addClass("simpleloader").html("");

			// hide higher steps
			$("#serie_container").hide();
			$("#artikel_container").hide();
			$("#draw").hide();
			$(".step1-intro").addClass('is-disabled');
			$(".step2-intro").addClass('is-disabled');


			var searchtext = $('.gpnrSearch-input').val();

			if (searchtext !== "") {
				if (searchtext.indexOf('-'))
					searchtext = searchtext.split('-')[0];

				scrollToId("#varianten_container");
				$.ajax({
					url: "/montageanleitung/list?style=montage&search=" + searchtext,
					success: function (data) {
						if (data && data !== "Keine Einträge gefunden!") {
							$("#varianten_container").removeClass("simpleloader").html(data);
						} else {
							$.ajax({
								url: "/montageanleitung/list?style=nomontage",
								success: function (data) {
									if (data) {
										$("#varianten_container").removeClass("simpleloader").html(data);
									}
								}
							})
						}
					}
				})
			}
			buildSelection();
		}


		function eteil_render(key) {
			// show draw
			$(".step4-intro").removeClass('is-disabled');
			$("#draw").show().addClass("simpleloader").html("");
			$('.tooltip').remove();

			if (key !== "") {
				scrollToId("#draw");
				$.ajax({
					url: "/montageanleitung/view/" + key + "?style=svg",
					success: function (data) {
						if (data) {
							$("#draw").removeClass("simpleloader").html(data);
							app.iconLoader.loadSvgs();
							hover_svg(key);
							// toggle eteile-tabelle
							$(".js-order-table-btn").on("click", function () {
								$(this).toggleClass('is-active');
								if ($(this).hasClass('is-active')) {
									$(this).text($(this).data("translation-hide"));
								} else {
									$(this).text($(this).data("translation-show"));
								}
								$('.js-order-table-extra').toggle()
							});
						}
					}
				})
			}
			buildSelection()
		}


		function hover_svg(id) {
			$('#draw svg text').hover(function () {
				$('.tooltip').remove();

				let hoveredOffset = $(this).offset();
				hoveredOffset['right'] = hoveredOffset.left + $(this).outerWidth();

				let adjacentElements = [];

				$.each($('#draw svg text'), function (key, obj) {
					let adjacentOffset = $(obj).offset();
					adjacentOffset['right'] = adjacentOffset.left + $(obj).outerWidth();

					if (hoveredOffset.left - 30 <= adjacentOffset.left
						&& hoveredOffset.right + 30 >= adjacentOffset.right
						&& hoveredOffset.top === adjacentOffset.top
					) { // if element near to
						adjacentElements.push($(obj))

						$(obj).css('fill', 'red');
					}
				});

				// sort elements from left to right
				adjacentElements.sort((a, b) => a.offset().left - b.offset().left);

				let offsetFirstElement = adjacentElements[0].offset();
				let index = adjacentElements.map(elem => elem.text()).join('').replace(/[^A-Za-z\d.\-#]/g, '');

				$.ajax({
					url: '/montageanleitung/view/' + id + '?style=json&pos=' + encodeURIComponent(index),
					success: function (data) {
						$('body').append('<div class="eteile tooltip" style="top:' + (offsetFirstElement.top + 40) + 'px;left:' + (offsetFirstElement.left - 30) + 'px">' + data + '</div>');

						$('.tooltip').mouseleave(() => {
							$('.tooltip').remove();
						});

						app.iconLoader.loadSvgs();
					}
				})
			}, function () {
				$('#draw svg text').css('fill', '');
			});
		}

		$(document).on("click", ".js-ordernow-eteilefinder", function (event) {
			event.preventDefault();

			var $this = $(this);
			var desc = $this.data('desc');
			var eteilNr = $this.data('eteilnr');
			var price = String($this.data('price')).replace(',', '.');
			var type = $this.data('type');
			var name = $this.data('name');
			var pos = $this.data('pos');

			$this.removeClass('btn--primary').addClass('btn--action').text($this.data('success-txt'));

			setTimeout(function () {
				$('html, body').animate({
					scrollTop: $('.js-sparepart-cart').offset().top
				}, 1000);
			}, 500);

			addToCart(desc, eteilNr, price, type, name, pos);

			return false;
		});

		function addToCart(desc, eteilNr, price, type, name, pos) {
			var processed = false;

			if (cart.length != 0) {
				cart.forEach(function (value, key) {
					if (value.desc == desc && value.eteilNr == eteilNr){
						cart[key].amount++;
						processed = true;
					}
				})
			}

			if (!processed) { // not existing in card >> push to cart
				cart.push({
					'desc': desc,
					'eteilNr': eteilNr,
					'price': price,
					'type': type,
					'name': name,
					'pos': pos,
					'amount': 1
				});
			}

			buildCart();
		}

		function buildCart() {
			var html = "";
			var sum = 0;

			cart.forEach(function (value, key) {
				html +=
					'<div class="cart-item" data-desc="' + value.desc + '" data-price="' + value.price + '" data-eteilnr="' + value.eteilNr + '">' +
						'<div class="cart-item-body">' +
							'<div class="cart-item-descr">' +
								'<div class="cart-item-artno">' + value.eteilNr + '&nbsp;</div>' +
								'<div class="cart-item-headline">' + value.desc + '&nbsp;</div>' +
							'</div>' +
							'<div class="cart-item-figures">' +
								'<div class="cart-item-figure cart-item-quantity">' +
									'<label class="floating-label floating-label--small" for="qty-' + value.eteilNr + '">Anzahl</label>' +
									'<input type="number"  min="0" max="99" id="qty-' + value.eteilNr + '" value="' + value.amount + '" class="js-item-amount-input input input--small">' +
								'</div>' +
								'<div class="cart-item-figure cart-item-delete">' +
									'<div class="floating-label floating-label--small">Löschen</div>' +
									'<a class="btn btn--small btn--light js-del-item" href="#" title="Aus dem Warenkorb löschen">Löschen</a>' +
								'</div>' +
								'<div class="cart-item-figure cart-item-unitprice">' +
									'<div class="floating-label floating-label--small">Stückpreis</div>' +
									'<span class="pt-price">' + formatPrice(value.price) + '</span>' +
								'</div>' +
								'<div class="cart-item-figure cart-item-availability">' +
									'<div class="floating-label floating-label--small">Verfügbarkeit</div>' +
									'<span class="availability availability--instock">Auf Lager</span>' +
								'</div>' +
								'<div class="cart-item-figure cart-item-total">' +
									'<div class="floating-label floating-label--small">Gesamtpreis</div>' +
									'<span class="pt-price">' + formatPrice(value.price * value.amount) + '</span>' +
								'</div>' +
							'</div>' +
						'</div>' +
					'</div>';

				sum += value.amount * value.price;
			});


			$('.eteile .step5-intro').removeClass('is-disabled');
			$('.eteile-form').removeClass('is-disabled');

			const taxes = parseFloat(document.querySelector('.js-eteil-cart-tax').dataset["taxes"]);
			const shipping = parseFloat(document.querySelector('.js-eteil-cart-shipping').innerText.replace(',', '.'));

			$('.eteile.js-sparepart-cart').removeClass('is-disabled');
			$('.eteile.js-sparepart-cart .cart-list').html(html);
			$('.js-eteil-cart-itemsum').text(formatPrice(sum));
			$('.js-eteil-cart-tax').text(formatPrice(sum / (100 + taxes) * taxes));
			$('.js-eteil-cart-endsum').text(formatPrice(sum + shipping));

			let json = JSON.stringify(cart);
			$('input[name="cartjson"]').val(json);

			$('.eteile.js-sparepart-cart .js-item-amount-input').change(function () {
				const val = $(this).val();
				const desc = $(this).closest('.cart-item').data('desc');

				updateCart('desc', desc, 'amount', val);
			});

			$('.eteile.js-sparepart-cart .js-del-item').click(function (event) {
				event.preventDefault();

				const desc = $(this).closest('.cart-item').data('desc');

				updateCart('desc', desc, null, '%delete%');

				return false;
			});
		}

		function updateCart(filterBy, filterVal, valueField, newValue, callback) {
			cart.forEach(function (value, key) {
				if (value[filterBy] == filterVal) {
					if (newValue === '%delete%' || parseInt(newValue) === 0) {
						delete cart[key];
					} else {
						cart[key][valueField] = newValue;
					}

					if (!!callback) {
						callback();
					}
				}
			});

			buildCart();
		}

		function scrollToId(element) {
			$('html, body').animate({scrollTop: ($(element).offset().top - 250)}, 'slow');
		}

		$("#submit-btn").click(function (e) {
			if (!($("#checkbox-agb").prop('checked'))) {
				e.preventDefault();
				$("js-checkbox-agb-box").addClass("is-invalid");
			}
		});


		// toggle lieferadresse
		$("#toggle_alt").on("click", function () {
			if ($(this).is(":checked")) {
				$("#alt").show()
			} else {
				$("#alt").hide()
			}
		});


		// handle path after page loaded
		let path = window.location.href.replace(self.baseURL + "/", "").split("/");
		handlePath(path[0], path[1]);

		// Deprecated, use /term/123 url
		let term = getUrlVar("term");
		if (term) {
			handlePath("term", term)
		}
	}
}
